export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/5583991755663?text=Olá!%20Gostaria%20de%20solicitar%20um%20atendimento%20da%20JampaBit."
      target="_blank"
      rel="nofollow noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 flex items-center justify-center bg-[#25D366] hover:bg-[#1ebe5d] rounded-full shadow-lg transition-all duration-200 hover:scale-110 cursor-pointer"
      aria-label="Falar no WhatsApp"
    >
      <i className="ri-whatsapp-line text-white text-2xl" />
    </a>
  );
}
